module.exports = __webpack_public_path__ + "static/media/LONG.0b6c21de.png";